import CHECK_EXPIRED_TOKEN_QUERY from '@/shared/api/queries/checkExpiredToken';
import type {
  CheckExpiredTokenQuery,
  CheckExpiredTokenQueryVariables,
} from '@/shared/api/generated/graphql';
import createClient from '../../client/apolloClient';

/**
 * Verifies with the server that the session token has not expired. Runs the checkExpiredToken query and throws when the returned status is anything other than 200.
 *
 * @returns A promise resolving once the token has been confirmed valid.
 */
const fetchCheckExpiredToken = async () => {
  const client = await createClient();
  const result = await client.query<CheckExpiredTokenQuery, CheckExpiredTokenQueryVariables>({
    query: CHECK_EXPIRED_TOKEN_QUERY,
  });
  if (result?.data?.checkExpiredToken !== 200) {
    throw new Error('Failed to check expired token');
  }
};

export default fetchCheckExpiredToken;
